
export enum LicenseEquipmentFuelTypeCd {
	DIESEL = 'Diesel',
	ELECTRIC = 'Electric',
	GAS = 'Gas',
	HYDROGEN = 'Hydrogen'}

